import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, NUMBER, STRING, UUID, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import Rate from '@/plugins/sdk/resources/RateCard/Rate'
import Group from '@/plugins/sdk/resources/RateCard/Group'
import Carrier from '@/plugins/sdk/resources/Carrier'
import Profile from '@/plugins/sdk/resources/Profile'
import Note from './Note'

export default class extends Resource {
  static name = 'ratecard'

  static get fields () {
    return {
      id: new UUID(),
      type: new STRING(),
      name: new STRING(),
      charge_account: new STRING(),
      printing_template: new STRING(),
      shipping_code: new STRING(),
      minimum: new STRING(),
      weight_limit: new STRING(),
      ref: new STRING(),
      round_weights_to: new NUMBER(),
      date_start: new DATETIME(),
      date_mod: new DATETIME(),
      date_end: new DATETIME(),
      active: new BOOLEAN(),
      deleted_at: new DATETIME(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      is_most_recent: new BOOLEAN(),
      rates: new COLLECTION(Rate),
      group: new ITEM(Group),
      carrier: new ITEM(Carrier),
      profile: new ITEM(Profile),
      code: new STRING(),
      notes: new COLLECTION(Note)
    }
  }

  static get sortables () {
    return [
      { field: 'name', label: 'Name' },
      { field: 'date_start', label: 'Start Date' },
      { field: 'date_end', label: 'End Date' },
      { field: 'created_at', label: 'Created Date' },
      { field: 'updated_at', label: 'Updated Date' },
      { field: 'carrier.carrier_name', label: 'Carrier Name' },
      { field: 'code', label: 'Code' },
      { field: 'charge_account', label: 'Charge Account' }
    ]
  }
}
